// Ouverture de la fenêtre expliquant le calcul des points de fidélité.
// Tout le reste — fond assombri, piège à focus, fermeture par Échap, retour du focus sur
// le bouton — est assuré par <dialog> et par les « form method="dialog" » du HTML.
// Seule l'ouverture demande du script.

document.addEventListener('click', function(evenement) {

    const bouton = evenement.target.closest('.js-club-detail-bouton');
    if (!bouton) return;

    // Le lien entre le bouton et sa fenêtre passe par aria-controls, déjà nécessaire à
    // l'accessibilité : pas d'attribut inventé pour le seul usage du script.
    const fenetre = document.getElementById(bouton.getAttribute('aria-controls'));
    if (!fenetre || typeof fenetre.showModal !== 'function') return;

    fenetre.showModal();
});


// Fermeture au clic sur le fond. <dialog> ne distingue pas le fond du contenu : l'un et
// l'autre sont la même cible d'événement. On ne ferme donc que si le clic tombe hors du
// rectangle de la fenêtre.
document.addEventListener('click', function(evenement) {

    const fenetre = evenement.target.closest('.js-club-detail');
    if (!fenetre || evenement.target !== fenetre) return;

    const zone = fenetre.getBoundingClientRect();
    const dedans = evenement.clientX >= zone.left && evenement.clientX <= zone.right
        && evenement.clientY >= zone.top && evenement.clientY <= zone.bottom;

    if (!dedans) {
        fenetre.close();
    }
});
